import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, tap } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ConfigServiceService {
  private configUrl = "./assets/settings.json";

  constructor(private http: HttpClient) {
    this.loadConfig();
  }

  loadConfig() {
    this.http
      .get<any>(this.configUrl)
      .pipe(
        tap((config) => {
          config.URL = document.location;
          environment.institucion = config.institucion;
          environment.paceholder = config.placeholder;
          environment.URL_HOME = `${config.URL}Home`;
          environment.emptyPaceholder = config.emptyPlaceholder;
        })
      )
      .subscribe();
  }
}

export function ConfigFactory(config: ConfigServiceService) {
  console.debug("ConfigFactory");
  return () => config.loadConfig();
}
